import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  standalone:  false,
  selector:    'app-case-creditor-info',
  templateUrl: './case-creditor-info.component.html'
})

export class CaseCreditorInfoComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CaseCreditorInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

}
